import { AddIcon, Button, Stack } from '@all-manager/design-system-v2';

type Props = {
  label: string;
  onClick: () => void;
};

/** Shows an optional field of an action form on demand. */
export default function RevealFieldButton(props: Props) {
  return (
    // Row so the button keeps its own width in the form column.
    <Stack direction="row">
      <Button variant="text" size="small" startIcon={<AddIcon fontSize="small" />} onClick={props.onClick}>
        {props.label}
      </Button>
    </Stack>
  );
}
